"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadResourceBundle = exports.parseResponse = void 0;
const parseResponse = (json) => {
    const result = {};
    Object.keys(json).forEach((key) => {
        const splitted = key.split('.');
        if (!splitted.length) {
            result[key] = json[key];
        }
        else {
            let ii = 0;
            // Assign reference to result object
            let tmpObj = result;
            // eslint-disable-next-line no-plusplus
            for (ii = 0; ii < splitted.length - 1; ii++) {
                // if this key doesn't exist assign an empty object
                tmpObj[splitted[ii]] = {};
                // Now tmpObj is 1 level deeper
                tmpObj = tmpObj[splitted[ii]];
            }
            // Assigne to the lowest level the value
            tmpObj[splitted[ii]] = json[key];
        }
    });
    return result;
};
exports.parseResponse = parseResponse;
const loadResourceBundle = (i18next, url, lng, ns, shouldParseResult = false) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(url, { cache: 'no-cache' });
        if (response.ok) {
            let result = yield response.json();
            if (shouldParseResult) {
                // This function mutates result
                result = (0, exports.parseResponse)(result.data);
            }
            if (Object.keys(result).length) {
                console.log(`Adding bundle for language ${lng}, namespace ${ns}`);
                /**
                 * Setting deep param to true will extend existing translations in that file.
                 * Setting deep and overwrite to true it will overwrite existing translations in that file.
                 */
                i18next.addResourceBundle(lng, ns, result, true, true);
            }
        }
    }
    catch (error) {
        console.error(`Cannot load translations for ${lng}/${ns}`);
    }
});
exports.loadResourceBundle = loadResourceBundle;
